export default {
  default: () => import("/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/layouts/default/Default.vue").then(m => m.default || m)
}